<template>
  <div class="download-loading" v-show="showDownloadLoading">
    <div class="download-loading__content">
      <div class="download-loading__lottie">
        <LottieAnimation
          :animationData="require('@/assets/lottie/download.json')"
          :loop="true"
          :autoPlay="true"
          :speed="1"
        />
      </div>
      <p class="download-loading__text">
        {{ showDownloadLoadingText || '資料處理中，請不要離開此畫面，感謝您的耐心等候。' }}
      </p>
    </div>
  </div>
</template>
<script>
import LottieAnimation from 'lottie-web-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadLoading',
  components: {
    LottieAnimation,
  },
  computed: {
    ...mapGetters(['showDownloadLoading', 'showDownloadLoadingText']),
  },
}
</script>

<style lang="scss" scoped>
$overlayColor: rgba(0, 0, 0, 0.75);
$textColor: #eee;

.download-loading {
  display: flex;
  width: 100%;
  height: 100dvh;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  background-color: $overlayColor;
  z-index: 9999 !important;

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__lottie {
    max-width: 300px;
    margin: 0 auto;
  }

  &__text {
    color: $textColor;
    font-size: 1rem;
    letter-spacing: 0.1em;
    line-height: 1.5rem;
    text-align: center;
    padding: 0 1rem;
  }
}
</style>
